const AlgoliaIndexMap = {
  development: 'staging',
  production: 'prod',
  staging: 'staging'
};

export default AlgoliaIndexMap;
